import type { FC } from 'react'
import { Skeleton } from '@/components/ui/skeleton'

export const StatsCardSkeleton: FC = () => {
    return (
        <div className="rounded-lg border bg-card h-[144px] flex flex-col">
            <div className="p-4 flex-1">
                <div className="flex items-center gap-2 mb-4">
                    <Skeleton className="h-5 w-5 rounded" />
                    <Skeleton className="h-4 w-32" />
                </div>
                <Skeleton className="h-9 w-40" />
            </div>
            <div className="bg-[#E1E4EA] px-4 py-2 rounded-b-lg">
                <Skeleton className="h-3 w-48" />
            </div>
        </div>
    )
}
